module.exports = __webpack_public_path__ + "img/logo.ce1f7814.png";